import { Injectable } from '@angular/core';
import {
  ApiCallHandler,
  EoHttpClient,
  IDataService,
  IHttpParams,
  PaginatedSearchResult,
  STATUS,
} from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { ISortParams } from '../../modules/shared/models/sort.model';
import { Observable } from 'rxjs';
import { IdikaSurgery } from '../../modules/core/models/idika-surgery.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeryIdikaService implements IDataService<IdikaSurgery> {
  private searchParams: {
    hospitalID: string;
    clinicID: string | null;
    dateFrom: Date | null;
    dateTo: Date | null;
    patientAmka: string | null;
    status: string | null;
    sortParams?: ISortParams | null;
  } | null = null;

  constructor(private http: EoHttpClient, private coreService: CoreService) {}
  public searchCh =
    new ApiCallHandler<PaginatedSearchResult<IdikaSurgery> | null>();
  public surgeryAssignCallHandler = new ApiCallHandler<any>();
  public surgeryAssignedCountCallHandler = new ApiCallHandler<number>();
  public surgeryUnAssignedCountCallHandler = new ApiCallHandler<number>();
  public surgeryMoveToPrivateClinicCallHandler = new ApiCallHandler<any>();

  init() {
    this.searchCh.init();
    this.surgeryAssignCallHandler.init();
    this.surgeryAssignedCountCallHandler.init();
    this.surgeryUnAssignedCountCallHandler.init();
    this.surgeryMoveToPrivateClinicCallHandler.init(null);
  }

  searchIdikaSurgeries(
    searchParams: {
      hospitalID: string;
      clinicID: string | null;
      dateFrom: Date | null;
      dateTo: Date | null;
      patientAmka: string | null;
      status: string | null;
      sortParams?: ISortParams | null;
    },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<IdikaSurgery>> {
    // Save searchParams for reuse
    this.searchParams = searchParams;

    const param: IHttpParams = this.coreService.initCall(
      `/v1/Surgeries/searchidika/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<IdikaSurgery>>(param);
  }

  getSavedSearchParams() {
    return this.searchParams;
  }

  assignSurgery(surgeryAssignBind: {
    hospitalID: string;
    surgeryIdikaListItemID: string;
    hospitalAvailabilityID: string;
  }) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/assign',
      this.surgeryAssignCallHandler,
      surgeryAssignBind
    );
    return this.http.post(param);
  }

  moveSurgeryToPrivateClinic(surgeryIdikaListItemID: string) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/toPrivateClinic',
      this.surgeryMoveToPrivateClinicCallHandler,
      { SurgeryIdikaListItemID: surgeryIdikaListItemID }
    );
    return this.http.post(param);
  }

  getAssignedCount(
    hospitalId?: string,
    clinicId?: string,
    patientAmka?: string
  ): Observable<number> {
    let bindObj: {
      hospitalID?: string | null;
      clinicID?: string | null;
      patientAmka?: string | null;
    } = {
      hospitalID: hospitalId ?? null,
      clinicID: clinicId ?? null,
      patientAmka: patientAmka ?? null,
    };

    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/assignedCount',
      this.surgeryAssignedCountCallHandler,
      bindObj
    );
    return this.http.post<number>(param);
  }

  getUnAssignedCount(
    hospitalId?: string,
    clinicId?: string,
    patientAmka?: string
  ): Observable<number> {
    let bindObj: {
      hospitalID?: string | null;
      clinicID?: string | null;
      patientAmka?: string | null;
    } = {
      hospitalID: hospitalId ?? null,
      clinicID: clinicId ?? null,
      patientAmka: patientAmka ?? null,
    };

    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/unassignedCount',
      this.surgeryUnAssignedCountCallHandler,
      bindObj
    );
    return this.http.post<number>(param);
  }
}
